import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

// Components //
import View from 'components/View';
import Title from 'components/Title';
import Subtitle from 'components/Subtitle';

const Root = styled(View)`

`;

const StepHeader = ({
  children,
  step,
  title,
  ...rest
}) => {
  return (
    <Root {...rest}>
      <Subtitle>{step === 7 ? 'Success' : `Step ${ step }/7`}</Subtitle>
      <Title
        style={{marginBottom: 24}}
      >
        { title }
      </Title>
      { children }
    </Root>
  );
}

StepHeader.propTypes = {
  step: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
};

export default StepHeader;
